//
//
//
//
//
//
//
//
//
//

export default {
  name: 'App',
  provide () {
    // 父组件中通过provide来提供变量，在子组件中通过inject来注入变量。
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      isRouterAlive: true
      // 控制视图是否显示的变量
    }
  },
  mounted () {
  },
  methods: {
    reload () {
      // 先关闭
      this.isRouterAlive = false
      this.$nextTick(function () {
        // 再打开
        this.isRouterAlive = true
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/App.vue